module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_c('strong', [_c('em', [_vm._v("Part I. Setting the Context")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("1. Judaism and the Love of Reason")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MARTHA C. NUSSBAUM")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Feminism, Socialism, and Christianity Revisited")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MARY B. MAHOWALD")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. “Philosophizing on Saturday”: Faith and the Philosophical Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("WINIFRED WING HAN LAMB")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Three Aspects of Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SR. MARY CHRISTINE MORKOVSKY")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Reflections on Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JEAN BETHKE ELSHTAIN")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Part II. Tensions and Integrations")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Yes")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MARIANNE SAWICKI")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Into the Crucible: My Art of Living")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("JACQUELINE SCOTT")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Learning to Question")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PATRICIA ALTENBERND JOHNSON")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. I Can’t Say No: Self-Sacrifice and an Ethics of Care")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("RUTH E. GROENHOUT")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Seduction: Does How You Get to “Yes” Still Matter?")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CAROLINE J. SIMON")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Living within Tradition")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LAURA DUHAN KAPLAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Hagar on My Mind")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("AZIZAH Y. AL-HIBRI")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('em', [_vm._v("Part III. Challenging Traditions")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. A Skeptical Spirituality")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NEL NODDINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Faith, Philosophy, Passions, and Feminism: Dangerous Attractions")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("IRMGARD SCHERER")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. On Being a Christian Philosopher and Not a Feminist")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("M. ELAINE BOTHA")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Toward a Visionary Politics: Phenomenology, Psychoanalytic Feminism, and Transcendence")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MARILYN NISSIM-SABAT")])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. My Life Speaks")])]), _vm._v(" "), _c('p', {
    staticClass: "toca"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("SARA EBENRECK")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors#con",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTRIBUTORS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0